export default __webpack_public_path__ + "static/media/security-icon4.e9eaef0f.svg";